export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      title: 'Đăng nhập', 
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/',
    meta: {roleId: 1},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/profile',
    meta: { title: 'Tài khoản', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/dashboard',
    meta: { title: 'Bảng điều khiển', breadcrumb: true, requiresAuth: true, roleId: 1 },
    name: 'Dashboard',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/don-hang/',
    meta: { title: 'Đơn hàng', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Tạo đơn mới', saveButton: true, saveButtonText: 'Xuất file', saveButtonIcon: 'fa-file-excel-o', refreshButton: true, roleId: 32 },
    name: 'OrderList',
    component: () => import(
      `@/views/Order/OrderList.vue`
    )
  },
  {
    path: '/don-hang/:Pid',
    meta: { title: 'Đơn hàng', breadcrumb: false, requiresAuth: true, roleId: 4096 },
    name: 'OrderDetail',
    component: () => import(
      `@/views/Order/OrderDetail.vue`
    )
  },
  {
    path: '/khach-hang/quan-ly-khach-hang',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'CustomerList',
    component: () => import(
      `@/views/Customer/CustomerList.vue`
    )
  },
  {
    path: '/khach-hang/quan-ly-khach-hang/:Pid',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: 'Reset password', createButtonIcon: 'fa-redo', roleId: 8 },
    name: 'CustomerDetail',
    component: () => import(
      `@/views/Customer/CustomerDetail.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-nap-tien/',
    meta: { title: 'Nạp tiền', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'RechargeHistory',
    component: () => import(
      `@/views/RechargeHistory/list.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-nap-tien/:Pid',
    meta: { title: 'Nạp tiền', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8 },
    name: 'RechargeDetail',
    component: () => import(
      `@/views/RechargeHistory/detail.vue`
    )
  },
  {
    path: '/nap-tien/',
    meta: { title: 'Nạp tiền', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, saveButtonText: 'NẠP TIỀN', roleId: 8 },
    name: 'RechargeNew',
    component: () => import(
      `@/views/RechargeHistory/list.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-thanh-toan/',
    meta: { title: 'Lịch sử thanh toán', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 8 },
    name: 'PaymentHistory',
    component: () => import(
      `@/views/PaymentHistory/PaymentHistoryList.vue`
    )
  },
  {
    path: '/khach-hang/lich-su-rut-tien/',
    meta: { title: 'Rút tiền', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 8 },
    name: 'WithdrawHistory',
    component: () => import(
      `@/views/WithdrawHistory/list.vue`
    )
  },
  {
    path: '/ke-toan/thanh-toan-don-hang/',
    meta: { title: 'Thanh toán tiền hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 128 },
    name: 'PayOrderList',
    component: () => import(
      `@/views/PayOrder/list.vue`
    )
  },
  {
    path: '/ke-toan/cong-no/',
    meta: { title: 'Công nợ', breadcrumb: true, requiresAuth: true, refreshButton: true, saveButton: true, saveButtonText: 'Xuất file', saveButtonIcon: 'fa-file-excel-o', roleId: 128 },
    name: 'bao-cao-cong-no',
    component: () => import(
      `@/views/Reports/bao-cao-cong-no.vue`
    )
  },
  {
    path: '/ke-toan/cong-no/:Pid',
    meta: { title: 'Công nợ khách hàng', breadcrumb: true, requiresAuth: true, roleId: 128 },
    name: 'bao-cao-cong-no-chi-tiet',
    component: () => import(
      `@/views/Reports/bao-cao-cong-no-chi-tiet.vue`
    )
  },
  {
    path: '/quan-ly-ma-van-don/ma-van-don/',
    meta: { title: 'Mã vận đơn', breadcrumb: true, requiresAuth: true, refreshButton: false, roleId: 512, roles: [64] },
    name: 'Transaction',
    component: () => import(
      `@/views/Transaction/list.vue`
    )
  },
  {
    path: '/quan-ly-ma-van-don/anh-kien-hang/',
    meta: { title: 'Khớp kiện', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Khớp đơn', roleId: 512, roles: [64] },
    name: 'Tracing',
    component: () => import(
      `@/views/Tracing/list.vue`
    )
  },
  {
    path: '/ky-gui/ky-gui-lo/',
    meta: { title: 'Nhập khẩu', breadcrumb: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: ' Import', otherButtonIcon: 'fa-file-excel-o', createButton: true, createButtonText: 'Tạo đơn mới', saveButton: true, saveButtonText: 'Xuất file', saveButtonIcon: 'fa-file-excel-o', roleId: 16 },
    name: 'DepositList',
    component: () => import(
      `@/views/Deposit/list.vue`
    )
  },
  {
    path: '/ky-gui/ky-gui-lo/:Pid',
    meta: { title: 'Nhập khẩu', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 16 },
    name: 'DepositDetail',
    component: () => import(
      `@/views/Deposit/detail.vue`
    )
  },
  {
    path: '/ky-gui/ky-gui-nguoc/',
    meta: { title: 'Xuất khẩu', breadcrumb: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: ' Import', otherButtonIcon: 'fa-file-excel-o', createButton: true, createButtonText: 'Tạo đơn mới', saveButton: true, saveButtonText: 'Xuất file', saveButtonIcon: 'fa-file-excel-o', roleId: 16 },
    name: 'DepositList2',
    component: () => import(
      `@/views/Deposit/list.vue`
    )
  },
  {
    path: '/ky-gui/ky-gui-nguoc/:Pid',
    meta: { title: 'Xuất khẩu', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 16 },
    name: 'DepositDetail2',
    component: () => import(
      `@/views/Deposit/detail.vue`
    )
  },
  {
    path: '/ky-gui/ky-gui-tmdt/',
    meta: { title: 'TMĐT', breadcrumb: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: ' Import', otherButtonIcon: 'fa-file-excel-o', createButton: true, createButtonText: 'Tạo mới', saveButton: true, saveButtonText: 'Xuất file', saveButtonIcon: 'fa-file-excel-o', roleId: 16 },
    name: 'EcommerceList',
    component: () => import(
      `@/views/Ecommerce/list.vue`
    )
  },
  {
    path: '/khieu-nai/don-hang/',
    meta: { title: 'Khiếu nại đơn hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4096 },
    name: 'Complain',
    component: () => import(
      `@/views/Complain/list.vue`
    )
  },
  {
    path: '/khieu-nai/don-hang/:Pid',
    meta: { title: 'Khiếu nại đơn hàng', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 4096 },
    name: 'ComplainDetail',
    component: () => import(
      `@/views/Complain/detail.vue`
    )
  },
  {
    path: '/khieu-nai/uqtt-ho/',
    meta: { title: 'Khiếu nại thanh toán hộ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4096 },
    name: 'PayAuthorityComplain',
    component: () => import(
      `@/views/Complain/payAuthList.vue`
    )
  },
  {
    path: '/khieu-nai/uqtt-ho/:Pid',
    meta: { title: 'Khiếu nại thanh toán hộ', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 4096 },
    name: 'AuthComplainDetail',
    component: () => import(
      `@/views/Complain/detail.vue`
    )
  },
  {
    path: '/khieu-nai/kien-tmdt/',
    meta: { title: 'Khiếu nại kiện TMĐT', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4096 },
    name: 'EcommerceComplain',
    component: () => import(
      `@/views/Complain/ecommerceList.vue`
    )
  },
  {
    path: '/khieu-nai/kien-tmdt/:Pid',
    meta: { title: 'Khiếu nại kiện TMĐT', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 4096 },
    name: 'EcommerceComplainDetail',
    component: () => import(
      `@/views/Complain/detail.vue`
    )
  },
  {
    path: '/kho-gui/quan-ly-kho/',
    meta: { title: 'Nhập kho TQ', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Tạo mới lô', otherButton: true, otherButtonText: 'Tạo mới kiện TMĐT', otherButtonIcon: 'fa-plus', refreshButton: true, roleId: 1024 },
    name: 'StoreManager',
    component: () => import(
      `@/views/StoreManager/list.vue`
    )
  },
  {
    path: '/kho-nhan/nhap-kho/',
    meta: { title: 'Nhập kho VN', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', refreshButton: true, roleId: 256 },
    name: 'StoreManagerVN',
    component: () => import(
      `@/views/StoreManagerVn/list.vue`
    )
  },
  {
    path: '/kho-nhan/nhap-kho/:Pid',
    meta: {title: 'Nhập kho VN', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập bao mới', saveButton: true, saveButtonText: 'Nhập mã vận đơn', saveButtonIcon: 'fas fa-align-left', roleId: 256 },
    name: 'StoreManagerVNDetail',
    component: () => import(
      `@/views/StoreManagerVn/detail.vue`
    )
  },
  {
    path: '/kho-trung-chuyen/nhap-kho/',
    meta: { title: 'Nhập kho trung chuyển', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', refreshButton: true, roleId: 256 },
    name: 'TranferStoreManager',
    component: () => import(
      `@/views/TranferStoreManager/list.vue`
    )
  },
  {
    path: '/kho-trung-chuyen/nhap-kho/:Pid',
    meta: {title: 'Nhập kho trung chuyển', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập bao mới', saveButton: true, saveButtonText: 'Nhập mvđ bổ xung', saveButtonIcon: 'fas fa-align-left', roleId: 256 },
    name: 'TranferStoreManagerDetail',
    component: () => import(
      `@/views/TranferStoreManager/detail.vue`
    )
  },
  {
    path: '/kho-trung-chuyen/nhap-kien/',
    meta: { title: 'Nhập kiện kho trung chuyển', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Nhập kho', saveButton: true, saveButtonText: 'Xuất kho', saveButtonIcon: 'fa-sign-out-alt', otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', refreshButton: true, roleId: 256 },
    name: 'TranferStoreManagerPackage',
    component: () => import(
      `@/views/TranferStoreManager/package.vue`
    )
  },
  {
    path: '/kho-nhan/luu-kho/',
    meta: { title: 'Lưu kho', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Tạo chuồng', refreshButton: true, roleId: 256 },
    name: 'StoreVNKennel',
    component: () => import(
      `@/views/StoreManagerVn/Kennel/list.vue`
    )
  },
  {
    path: '/kho-nhan/luu-kho/:Pid',
    meta: { title: 'Lưu kho', breadcrumb: true, requiresAuth: true, saveButton: true, saveButtonText: 'Lưu lại', saveButtonIcon: 'fas fa-align-left', roleId: 256 },
    name: 'StoreVNKennelDetail',
    component: () => import(
      `@/views/StoreManagerVn/Kennel/detail.vue`
    )
  },
  {
    path: '/kho-nhan/kiem-kho/',
    meta: { title: 'Kiểm kho', breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: 'Tạo phiếu', refreshButton: true, roleId: 256 },
    name: 'StoreVNCheck',
    component: () => import(
      `@/views/StoreManagerVn/Check/list.vue`
    )
  },
  {
    path: '/kho-nhan/kiem-kho/:Pid',
    meta: { title: 'Kiểm kho', breadcrumb: true, requiresAuth: true, saveButton: true, saveButtonText: 'Lưu lại', saveButtonIcon: 'fas fa-align-left', roleId: 256 },
    name: 'StoreVNCheckDetail',
    component: () => import(
      `@/views/StoreManagerVn/Check/detail.vue`
    )
  },
  {
    path: '/kho-gui/quan-ly-bao-hang/',
    meta: { title: 'Bao hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2048 },
    name: 'BigPackage',
    component: () => import(
      `@/views/BigPackage/list.vue`
    )
  },
  {
    path: '/doi-soat-bao-hang/',
    meta: { title: 'Đối soát bao hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 2048 },
    name: 'CheckBigpackage',
    component: () => import(
      `@/views/CheckBigpackage/list.vue`
    )
  },
  {
    path: '/doi-soat-bao-hang/:Pid',
    meta: { title: 'Chi tiết đối soát bao hàng', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 2048 },
    name: 'CheckBigpackageDetail',
    component: () => import(
      `@/views/CheckBigpackage/detail.vue`
    )
  },
  {
    path: '/xuat-kho/ma-van-don',
    meta: {title: 'Danh sách kiện xuất', breadcrumb: true, requiresAuth: true, createButton: false, refreshButton: true, roleId: 512 },
    name: 'Deliverable',
    component: () => import(
      `@/views/Deliverable/list.vue`
    )
  },
  {
    path: '/xuat-kho/phieu-xuat-kho',
    meta: {title: 'Phiếu xuất kho', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 512 },
    name: 'ExportReceipt',
    component: () => import(
      `@/views/ExportReceipt/list.vue`
    )
  },
  {
    path: '/xuat-kho/phieu-xuat-kho/:Pid',
    meta: { title: 'Chi tiết phiếu xuất', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 512 },
    name: 'ExportReceiptDetail',
    component: () => import(
      `@/views/ExportReceipt/detail.vue`
    )
  },
  {
    path: '/ke-toan/kiem-soat-don-hang/',
    meta: { title: 'Kiểm soát đơn hàng',  breadcrumb: true, requiresAuth: true, createButton: true, createButtonText: ' Export', createButtonIcon: 'fa-file-excel-o', refreshButton: true, roleId: 128 },
    name: 'AccountantOrder',
    component: () => import(
      `@/views/AccountantOrder/list.vue`
    )
  },
  {
    path: '/ke-toan/luong-thu-chi/',
    meta: { title: 'Luồng thu chi (¥)', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128 },
    name: 'AccountantCumulationList',
    component: () => import(
      `@/views/AccountantCumulation/list.vue`
    )
  },
  {
    path: '/ke-toan/luong-thu-chi/:Pid',
    meta: {title: 'Chi tiết thu/chi (¥)', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 128 },
    name: 'AccountantCumulationDetail',
    component: () => import(
      `@/views/AccountantCumulation/detail.vue`
    )
  },
  {
    path: '/ke-toan/luong-thu-chi-vnd/',
    meta: { title: 'Luồng thu chi (₫)', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128 },
    name: 'AccountantCumulationVNDList',
    component: () => import(
      `@/views/AccountantCumulationVND/list.vue`
    )
  },
  {
    path: '/ke-toan/luong-thu-chi-vnd/:Pid',
    meta: {title: 'Chi tiết thu/chi (₫)', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 128 },
    name: 'AccountantCumulationVNDDetail',
    component: () => import(
      `@/views/AccountantCumulationVND/detail.vue`
    )
  },
  {
    path: '/ke-toan/hoan-tien-tuikuan/',
    meta: { title: 'Shop hoàn tiền KN', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 128 },
    name: 'TuiKuanList',
    component: () => import(
      `@/views/TuiKuan/list.vue`
    )
  },
  {
    path: '/ke-toan/hoan-tien-tuikuan/:Pid',
    meta: {title: 'Chi tiết hoàn tiền', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 128 },
    name: 'TuiKuanDetail',
    component: () => import(
      `@/views/TuiKuan/detail.vue`
    )
  },
  //==================CAI DAT========================
  {
    path: '/cai-dat/chiet-khau-hoa-hong/',
    meta: { title: 'CK hoa hồng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeWeightCommissionList',
    component: () => import(
      `@/views/FeeWeightCommission/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/',
    meta: { title: 'Phí cân nặng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeWeightList',
    component: () => import(
      `@/views/FeeWeight/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-can-nang/:Pid',
    meta: { title: 'Phí cân nặng', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeWeightDetail',
    component: () => import(
      `@/views/FeeWeight/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/',
    meta: { title: 'Phí khối', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeVolumeList',
    component: () => import(
      `@/views/FeeVolume/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-khoi/:Pid',
    meta: { title: 'Phí khối', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeVolumeDetail',
    component: () => import(
      `@/views/FeeVolume/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-kiem-dem/',
    meta: { title: 'Phí kiểm đếm', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeCheckList',
    component: () => import(
      `@/views/FeeCheck/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-kiem-dem/:Pid',
    meta: { title: 'Phí kiểm đếm', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeCheckDetail',
    component: () => import(
      `@/views/FeeCheck/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-bao-hiem/',
    meta: { title: 'Phí bảo hiểm', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeGuaranteeList',
    component: () => import(
      `@/views/FeeGuarantee/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-bao-hiem/:Pid',
    meta: { title: 'Phí bảo hiểm', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeGuaranteeDetail',
    component: () => import(
      `@/views/FeeGuarantee/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-gia-co/',
    meta: { title: 'Phí gia cố', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeReinforceList',
    component: () => import(
      `@/views/FeeReinforce/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-gia-co/:Pid',
    meta: { title: 'Phí gia cố', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeReinforceDetail',
    component: () => import(
      `@/views/FeeReinforce/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-bot-khi/',
    meta: { title: 'Phí bọt khí', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeFoamList',
    component: () => import(
      `@/views/FeeFoam/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-bot-khi/:Pid',
    meta: { title: 'Phí bọt khí', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeFoamDetail',
    component: () => import(
      `@/views/FeeFoam/detail.vue`
    )
  },
  {
    path: '/cai-dat/phi-mua-hang/',
    meta: { title: 'Phí mua hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeBuyList',
    component: () => import(
      `@/views/FeeBuy/list.vue`
    )
  },
  {
    path: '/cai-dat/phi-mua-hang/:Pid',
    meta: { title: 'Phí mua hàng', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FeeBuyDetail',
    component: () => import(
      `@/views/FeeBuy/detail.vue`
    )
  },
  {
    path: '/cai-dat/cau-hinh-chung',
    meta: { title: 'Cấu hình chung', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'Configuration',
    component: () => import(
      `@/views/Configuration/detail.vue`
    )
  },
  {
    path: '/cai-dat/bang-gia-tt',
    meta: { title: 'Bảng giá thanh toán', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 64 },
    name: 'ConfigPrice',
    component: () => import(
      `@/views/ConfigPrice/detail.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/',
    meta: { title: 'Nhân viên', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'StaffList',
    component: () => import(
      `@/views/Staff/list.vue`
    )
  },
  {
    path: '/cai-dat/nhan-vien/:Pid',
    meta: { title: 'Nhân viên', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'StaffDetail',
    component: () => import(
      `@/views/Staff/detail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-level/',
    meta: { title: 'Khách hàng thân thiết', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, saveButton: true, saveButtonText: 'Ignore', saveButtonIcon: 'fas fa-ban', roleId:2, reportRoleId: 128 },
    name: 'CustomerLevel',
    component: () => import(
      `@/views/CustomerLevel/CustomerLevelList.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-level/:Pid',
    meta: { title: 'Khách hàng thân thiết', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'CustomerLevelDetail',
    component: () => import(
      `@/views/CustomerLevel/CustomerLevelDetail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-gui/',
    meta: { title: 'Kho gửi', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'ChinaStoreList',
    component: () => import(
      `@/views/ChinaStore/list.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-gui/:Pid',
    meta: { title: 'Kho gửi', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'ChinaStoreDetail',
    component: () => import(
      `@/views/ChinaStore/detail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-trung-chuyen/',
    meta: { title: 'Kho gửi', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'TranferStoreList',
    component: () => import(
      `@/views/TranferStore/list.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-trung-chuyen/:Pid',
    meta: { title: 'Kho gửi', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'TranferStoreDetail',
    component: () => import(
      `@/views/TranferStore/detail.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-nhan/',
    meta: { title: 'Kho nhận', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'WarehouseList',
    component: () => import(
      `@/views/Warehouse/list.vue`
    )
  },
  {
    path: '/cai-dat/quan-ly-kho-nhan/:Pid',
    meta: { title: 'Kho nhận', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'WarehouseDetail',
    component: () => import(
      `@/views/Warehouse/detail.vue`
    )
  },
  {
    path: '/cai-dat/bang-gia-van-chuyen/',
    meta: { title: 'Bảng giá vận chuyển', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, otherButton: true, otherButtonText: 'Xem log', otherButtonIcon: 'fa-book', roleId:2, reportRoleId: 128 },
    name: 'PricesList',
    component: () => import(
      `@/views/Prices/list.vue`
    )
  },
  {
    path: '/cai-dat/bang-gia-van-chuyen/:Pid',
    meta: { title: 'Bảng giá vận chuyển', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'PricesDetail',
    component: () => import(
      `@/views/Prices/detail.vue`
    )
  },
  {
    path: '/cai-dat/hashtag/',
    meta: { title: 'Hashtag',breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'FlagList',
    component: () => import(
      `@/views/Flag/list.vue`
    )
  },
  {
    path: '/cai-dat/hashtag/:Pid',
    meta: { title: 'Hashtag', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'FlagDetail',
    component: () => import(
      `@/views/Flag/detail.vue`
    )
  },
  {
    path: '/cai-dat/cap-do-an-toan/',
    meta: { title: 'Cấp độ an toàn', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId:2, reportRoleId: 128 },
    name: 'SafeLevelList',
    component: () => import(
      `@/views/SafeLevel/list.vue`
    )
  },
  {
    path: '/cai-dat/cap-do-an-toan/:Pid',
    meta: { title: 'Cấp độ an toàn', breadcrumb: true, requiresAuth: true, saveButton: true, roleId:2, reportRoleId: 128 },
    name: 'SafeLevelDetail',
    component: () => import(
      `@/views/SafeLevel/detail.vue`
    )
  },
  {
    path: '/thong-bao/',
    meta: { title: 'Thông báo', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1 },
    name: 'NotificationList',
    component: () => import(
      `@/views/Notification/list.vue`
    )
  },
  //==================BAO CAO========================
  {
    path: '/bao-cao/loi-nhuan-dat-hang/',
    meta: { title: 'Thống kê lợi nhuận đặt hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 1 },
    name: 'thong-ke-loi-nhuan-dat-hang',
    component: () => import(
      `@/views/Reports/thong-ke-loi-nhuan-dat-hang.vue`
    )
  },
  {
    path: '/bao-cao/phi-mua-hang/',
    meta: { title: 'Thống kê phí mua hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 2 },
    name: 'thong-ke-phi-mua-hang',
    component: () => import(
      `@/views/Reports/thong-ke-phi-mua-hang.vue`
    )
  },
  {
    path: '/bao-cao/phi-van-chuyen/',
    meta: { title: 'Thống kê phí vận chuyển', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 4 },
    name: 'thong-ke-phi-van-chuyen',
    component: () => import(
      `@/views/Reports/thong-ke-phi-van-chuyen.vue`
    )
  },
  {
    path: '/bao-cao/tien-te/',
    meta: { title: 'Thống kê tiền tệ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'thong-ke-tien-te',
    component: () => import(
      `@/views/Reports/thong-ke-tien-te.vue`
    )
  },
  {
    path: '/ke-toan/tai-chinh/',
    meta: { title: 'Tài chính', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 16, otherButton: true, otherButtonText: 'Xem log', otherButtonIcon: 'fa-book', saveButton: true, saveButtonText: 'Chuyển tiền', saveButtonIcon: 'fa-redo', createButton: true, createButtonText: 'Thu Chi', createButtonIcon: 'fa-money-bill-alt', exportButton: true},
    name: 'bao-cao-tai-chinh',
    component: () => import(
      `@/views/Reports/bao-cao-tai-chinh.vue`
    )
  },
  {
    path: '/bao-cao/nap-tien/',
    meta: { title: 'Thống kê phí vận chuyển', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-nap-tien',
    component: () => import(
      `@/views/Reports/bao-cao-nap-tien.vue`
    )
  },
  {
    path: '/bao-cao/tong-hop/',
    meta: { title: 'Báo cáo doanh thu', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-tong-hop',
    component: () => import(
      `@/views/Reports/bao-cao-tong-hop.vue`
    )
  },
  {
    path: '/bao-cao/doanh-thu/',
    meta: { title: 'Báo cáo doanh thu', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-doanh-thu',
    component: () => import(
      `@/views/Reports/bao-cao-doanh-thu.vue`
    )
  },
  {
    path: '/bao-cao/thong-ke-hoa-hong-nhan-vien/',
    meta: { title: 'Thống kê hoa hồng nhân viên', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'thong-ke-hoa-hong-nhan-vien',
    component: () => import(
      `@/views/Reports/thong-ke-hoa-hong-nhan-vien.vue`
    )
  },
  {
    path: '/bao-cao/van-hanh-kho/',
    meta: { title: 'Báo cáo vận hành kho', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 8 },
    name: 'bao-cao-van-hanh-kho',
    component: () => import(
      `@/views/Reports/bao-cao-van-hanh-kho.vue`
    )
  },
  {
    path: '/bao-cao/no-xau/',
    meta: { title: 'Báo cáo nợ quá hạn - nợ xấu', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 4, reportRoleId: 1 },
    name: 'bao-cao-no-xau',
    component: () => import(
      `@/views/Reports/bao-cao-no-xau.vue`
    )
  },
  {
    path: '/thanh-toan-ho/truc-tiep/',
    meta: { title: 'Thanh toán trực tiếp', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Tạo đơn mới', otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', roleId: 64 },
    name: 'PayServiceList',
    component: () => import(
      `@/views/PayService/list.vue`
    )
  },
  {
    path: '/thanh-toan-ho/truc-tiep/:Pid',
    meta: { title: 'Chi tiết thanh toán trực tiếp', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 64 },
    name: 'PayServiceDetail',
    component: () => import(
      `@/views/PayService/detail.vue`
    )
  },
  {
    path: '/thanh-toan-ho/uy-quyen/',
    meta: { title: 'Thanh toán ủy quyền', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Tạo đơn ủy quyền', otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', roleId: 64 },
    name: 'PayAuthorityList',
    component: () => import(
      `@/views/PayAuthority/list.vue`
    )
  },
  {
    path: '/thanh-toan-ho/uy-quyen/:Pid',
    meta: { title: 'Chi tiết ủy quyền thanh toán', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 64 },
    name: 'PayAuthorityDetail',
    component: () => import(
      `@/views/PayAuthority/detail.vue`
    )
  },
  {
    path: '/kho-gui/thu-chi-kho-gui/',
    meta: { title: 'Thu chi kho gửi', breadcrumb: true, createButton: true, requiresAuth: true, refreshButton: true, roleId: 8192 },
    name: 'StoreReportList',
    component: () => import(
      `@/views/StoreReport/list.vue`
    )
  },
  {
    path: '/kho-gui/thu-chi-kho-gui/:Pid',
    meta: { title: 'Chi tiết thu chi', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 8192 },
    name: 'StoreReportDetail',
    component: () => import(
      `@/views/StoreReport/detail.vue`
    )
  },
  {
    path: '/thu-chi-noi-bo/',
    meta: { title: 'Thu chi nội bộ', breadcrumb: true, createButton: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', roleId: 32768 },
    name: 'InternalFinanceList',
    component: () => import(
      `@/views/InternalFinance/list.vue`
    )
  },
  {
    path: '/thu-chi-noi-bo/:Pid',
    meta: { title: 'Chi tiết thu chi', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 32768 },
    name: 'InternalFinanceDetail',
    component: () => import(
      `@/views/InternalFinance/detail.vue`
    )
  },
  {
    path: '/hashtag-don-hang/',
    meta: { title: 'Hashtag đơn hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32 },
    name: 'hashtag-don-hang',
    component: () => import(
      `@/views/Reports/kiem-soat-don-hang.vue`
    )
  },
  {
    path: '/yeu-cau-giao-hang/',
    meta: { title: 'Yêu cầu giao hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, roleId: 262144 },
    name: 'PaymentRequest',
    component: () => import(
      `@/views/PaymentRequest/list.vue`
    )
  },
  {
    path: '/yeu-cau-giao-hang/:Pid',
    meta: { title: 'Chi tiết yêu cầu giao hàng', breadcrumb: true, requiresAuth: true, saveButton: false, roleId: 262144 },
    name: 'PaymentRequestDetail',
    component: () => import(
      `@/views/PaymentRequest/detail.vue`
    )
  },
  {
    path: '/lead-manager/lien-he/',
    meta: { title: 'Danh sách liên hệ', breadcrumb: true, requiresAuth: true, otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', refreshButton: true, createButton: true, createButtonText: 'Tạo mới liên hệ', roleId: 65536 },
    name: 'ContactList',
    component: () => import(
      `@/views/LeadManager/Contact/list.vue`
    )
  },
  {
    path: '/lead-manager/lien-he/:Pid',
    meta: { title: 'Chi tiết liên hệ', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 65536 },
    name: 'ContactDetail',
    component: () => import(
      `@/views/LeadManager/Contact/detail.vue`
    )
  },
  {
    path: '/lead-manager/cham-soc-lien-he/',
    meta: { title: 'Chăm sóc liên hệ', breadcrumb: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', createButton: true, createButtonText: 'Tạo mới', roleId: 65536 },
    name: 'ContactCareList',
    component: () => import(
      `@/views/LeadManager/ContactCare/main.vue`
    )
  },
  {
    path: '/lead-manager/co-hoi/',
    meta: { title: 'Cơ hội', breadcrumb: true, requiresAuth: true, refreshButton: true, otherButton: true, otherButtonText: 'Xuất file', otherButtonIcon: 'fa-file-excel-o', createButton: true, createButtonText: 'Tạo mới', roleId: 65536 },
    name: 'OpportunityKaban',
    component: () => import(
      `@/views/LeadManager/Opportunity/main.vue`
    )
  },
  {
    path: '/lead-manager/khach-hang/',
    meta: { title: 'Khách hàng từ liên hệ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 65536 },
    name: 'ContactCustomerList',
    component: () => import(
      `@/views/LeadManager/ContactCustomer/main.vue`
    )
  },
  {
    path: '/lead-manager/bc-tong-hop/',
    meta: { title: 'Báo cáo liên hệ', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 65536 },
    name: 'ContactReport',
    component: () => import(
      `@/views/LeadManager/ContactReport/main.vue`
    )
  },
  {
    path: '/tin-nhan-nap-tien/',
    meta: { title: 'Tin nhắn nạp tiền', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 131072, roles: [12] },
    name: 'BankMessages',
    component: () => import(
      `@/views/BankMessages/list.vue`
    )
  },
  {
    path: '/kho-gui/canh-bao-kien-hang/',
    meta: { title: 'Cảnh báo kiện hàng', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 1024 },
    name: 'PackageWarning',
    component: () => import(
      `@/views/PackageWarning/list.vue`
    )
  },
  {
    path: '/voucher/quan-ly-voucher/',
    meta: { title: 'Quản lý voucher', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, roleId: 32 },
    name: 'VoucherList',
    component: () => import(
      `@/views/Voucher/list.vue`
    )
  },
  {
    path: '/voucher/quan-ly-voucher/:Pid',
    meta: { title: 'Chi tiết voucher', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 32 },
    name: 'VoucherDetail',
    component: () => import(
      `@/views/Voucher/detail.vue`
    )
  },
  {
    path: '/voucher/bao--cao-voucher/',
    meta: { title: 'Báo cáo voucher', breadcrumb: true, requiresAuth: true, refreshButton: true, roleId: 32 },
    name: 'VoucherReport',
    component: () => import(
      `@/views/Voucher/report.vue`
    )
  },
  {
    path: '/zns/tin-quang-cao/',
    meta: { title: 'ZNS quảng cáo', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, roleId: 32 },
    name: 'ZnsMsgList',
    component: () => import(
      `@/views/ZnsMsg/list.vue`
    )
  },
  {
    path: '/zns/thong-bao/',
    meta: { title: 'ZNS thông báo', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Cấu hình', roleId: 32 },
    name: 'ZnsNotiList',
    component: () => import(
      `@/views/ZnsNoti/list.vue`
    )
  },
  {
    path: '/quan-ly-ma-hs/',
    meta: { title: 'Mã HS', breadcrumb: true, requiresAuth: true, refreshButton: true, createButton: true, createButtonText: 'Tạo mới', otherButton: true, otherButtonText: ' Import', otherButtonIcon: 'fa-file-excel-o', roleId: 1 },
    name: 'HsCodeList',
    component: () => import(
      `@/views/HsCode/list.vue`
    )
  },
];
